
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DrawerService {
    private drawerState = new BehaviorSubject<boolean>(false);
    currentDrawerState = this.drawerState.asObservable();

    constructor() {
    }

    toggleDrawer() {
        this.drawerState.next(this.drawerState.value);
    }

    openDrawer() {
        this.drawerState.next(true);
    }

    closeDrawer() {
        this.drawerState.next(false);
    }
}
